const ON_CHANGE_DEBOUNCE_TIMER = 300

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
}

let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback]

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    })
  }
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}

function formatCurrency(amount, locale = "en-US", currency = "USD") {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(amount)
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener("focusout", trapFocusHandlers.focusout)
  document.addEventListener("focusin", trapFocusHandlers.focusin)

  elementToFocus.focus()
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*")
  })
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*")
  })
  document.querySelectorAll("video").forEach((video) => video.pause())
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin)
  document.removeEventListener("focusout", trapFocusHandlers.focusout)
  document.removeEventListener("keydown", trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector("input")
    this.changeEvent = new Event("change", { bubbles: true })

    this.input.addEventListener("change", this.onInputChange.bind(this))
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)))
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
    this.changeBtnPrice()
  }

  changeBtnPrice() {
    const btn = document.querySelector(".product-add-to-cart")
    const value = parseInt(this.input.value)

    const $text = document.querySelector(".product-add-to-cart span:first-child")
    const $comparePriceElement = btn.querySelector(".button-text.compare_at")

    const subElm = document.querySelector("#purchaseTypeSubscription")

    const mainText = "Add To Cart"

    if (btn) {
      const price = Number(btn.getAttribute("data-price"))
      const comparePrice = Number(btn.getAttribute("data-compare-price"))

      let main = price * value

      if (subElm.checked) {
        const final = main - main * 0.15
        $text.innerText = `${mainText} - ${final.toLocaleString("en-US", { style: "currency", currency: "USD" })}`
      } else {
        $text.innerText = `${mainText} - $${main}`
      }

      if (!comparePrice && subElm.checked) {
        $comparePriceElement.innerText = Number(main).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })
      } else if (!comparePrice && !subElm) {
        $comparePriceElement.innerText = ""
      }
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle("disabled", value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle("disabled", value >= max)
    }
  }
}

customElements.define("quantity-input", QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  }
}

function insertParam(key, value) {
  const defaultUrl = window.location.href
  const url = new URL(defaultUrl)

  let search_params = url.searchParams
  search_params.set(key, value)

  return search_params.toString()
}

function deleteParam(key) {
  let url = new URL(window.location.href)
  let params = new URLSearchParams(url.search)

  params.delete(key)

  return params.toString()
}

function getAllParam() {
  let url = new URL(window.location.href)
  let params = new URLSearchParams(url.search)

  return params.toString()
}

async function insertCartStat(type) {
  try {
    const response = await fetch("/apps/bbe-checkout-app/api/cart/view", {
      method: "POST",
      body: JSON.stringify({
        type: type,
      }),
    })

    if (!response.ok) {
      console.log("Network error")
      return
    }

    const results = await response.json()
    console.log(results)
  } catch (error) {
    console.error(error)
  }
}

if (!customElements.get("color-swatch-radio")) {
  customElements.define(
    "color-swatch-radio",
    class extends HTMLElement {
      constructor() {
        super()

        this.btns = this.querySelectorAll('[role="radio"]')
        this.btns.forEach((btn) =>
          btn.addEventListener("click", () => {
            this.onChange(btn)
          }),
        )

        this.label = this.querySelector("label")
        this.price = this.querySelector(".color-swatch__price")

        // Call checkSelected when the custom element is loaded
        this.checkSelected()
      }

      onChange(btn) {
        this.btns.forEach((btn) => btn.classList.remove("active"))
        btn.classList.add("active")

        //Change price and label
        this.label.textContent = btn.getAttribute("data-label")
        this.price.textContent = btn.getAttribute("data-price")

        //Change form input
        const form = this.closest("form")
        const input = form.querySelector('input[name="id"]')
        input.value = btn.getAttribute("data-variant-id")
      }

      checkSelected() {
        const selected = this.querySelector(".color-swatch-btn.active")
        if (selected) this.onChange(selected)
      }
    },
  )
}
